import type { Demand, Requirement } from '@/types/knowledge_graph'
import { RequirementRow } from '../components/RequirementRow'

interface Props {
  requirements: Requirement[]
  demands: Demand[]
  onUpdateRequirement: (requirementId: string, changes: Partial<Requirement>) => void
}

export function RequirementsTab ({ requirements, demands, onUpdateRequirement }: Props): React.ReactElement {
  const approvedCount = requirements.filter((r) => r.review_status === 'approved').length

  return (
    <>
      <div className='section-head'>
        <h3>要件一覧</h3>
        <span className='count'>{requirements.length}件 — {approvedCount}件確認済</span>
      </div>
      <div style={{
        fontSize: 11,
        color: 'var(--bp-ink3)',
        marginBottom: 10,
        display: 'flex',
        alignItems: 'center',
        gap: 6
      }}
      >
        内容を確認したらチェックを入れてください。
      </div>
      {requirements.length === 0
        ? (
          <div style={{ color: 'var(--bp-ink3)', fontSize: 13 }}>要件がありません</div>
          )
        : (
          <div className='rel-table-wrap'>
            <table>
              <thead>
                <tr>
                  <th style={{ width: 36 }} />
                  <th style={{ width: 56 }}>ID</th>
                  <th style={{ width: 96 }}>根拠</th>
                  <th>要件</th>
                  <th style={{ width: 96 }}>種別</th>
                  <th style={{ width: 68 }}>要求</th>
                  <th style={{ width: 36 }} />
                </tr>
              </thead>
              <tbody>
                {requirements.map((r) => (
                  <RequirementRow
                    key={r.id}
                    requirement={r}
                    demands={demands}
                    onUpdate={(changes) => onUpdateRequirement(r.id, changes)}
                  />
                ))}
              </tbody>
            </table>
          </div>
          )}
    </>
  )
}
